<template>
  <RF-Aba :cpntButtons='buttons'></RF-Aba>
</template>

<script>
  export default {
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba.vue')
    },
    data: function () {
      return {
        buttons: []
      }
    },
    mounted: function () {
      this.appConfigMontarAbas()  
    },
    methods: {
      appConfigMontarAbas: function () {
        // RESETA O MENU EXISTENTE
        this.buttons = []
  
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 1 ], null, [ 3 ], null, [ 720, 710, 68 ], 'or', false) === false) {
          this.$router.push({ name: 'erro_perfil' })
        } else {
          // ADICIONA A ABA CADASTRO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 1 ], null, [ 3 ], null, [ 68 ], null, false) === true) {
            this.buttons.push({ nome: 'Meu Cadastro', router: this.$router.resolve({ name: 'config_cadastro', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'config_cadastro' ] })
          }
  
          // ADICIONA A ABA LOGOTIPO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 1 ], null, [ 3 ], null, [ 710 ], null, false) === true) {
            this.buttons.push({ nome: 'Logotipo', router: this.$router.resolve({ name: 'config_logotipo', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'config_logotipo' ] })
          }
  
          // VERIFICA SE TEM O PACOTE
          // 20 = NF-e
          // 23 = NFC-e
          // 25 = NFS-e
          // 31 = DF-e RECEBIDOS
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20, 25, 23, 31 ], 'or', null, null, null, null, false) === true) {
            this.buttons.push({ nome: 'Certificado Digital', router: this.$router.resolve({ name: 'config_certificado', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'config_certificado' ] })
          }
  
          // ABA DE PACOTES
          this.buttons.push({ nome: 'Pacotes', router: this.$router.resolve({ name: 'pacotes_contratados', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'pacotes_contratados' ] })
  
          // VERIFICA SE NÃO É UM CONTADOR
          if ((this.$store.state.token.clu_mu === 'a' || this.$store.state.token.clu_pu === 'a') && this.$store.state.token.contador === false) {
            // VERIFICA O TIPO DE CONTRATO QUE ESTA NO TOKEN
            if (this.$store.state.token.clu_con !== 'l' && this.$store.state.token.clu_con !== 'lv') {
              // ADICIONA A ABA CONTRATO DEMONSTRATIVO
              this.buttons.push({ nome: 'Contrato Demonstrativo', router: this.$router.resolve({ name: 'config_termos_demonstrativo', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'config_termos_demonstrativo' ] })
            }
    
            // ADICIONA A ABA CONTRATO LICENÇA DE USO
            this.buttons.push({ nome: 'Contrato de Licença de Uso', router: this.$router.resolve({ name: 'contrato_licenca_uso', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'contrato_licenca_uso' ] })
          }
        }
      }
    },
    watch: {
      '$store.state.token.token': function () {
        this.appConfigMontarAbas()
      }
    }
  }
</script>
